import { createContext, useContext, useMemo, useState } from "react";
import { fetchData } from "../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";

const DomesticMarketTopPriceChangesContext = createContext();
const DomesticMarketTopPriceChangesProvider = ({ children }) => {
  const [symbolChecked, setSymbolChecked] = useState(true);

  const [searchParams] = useSearchParams();

  const topPriceChanges = useSWR(
    `/domestic/top-price-change?${searchParams.toString()}`,
    fetchData,
    {
      dedupingInterval: 36000,
    }
  );

  const filteredData = useMemo(() => {
    return symbolChecked
      ? topPriceChanges.data?.filter((item) => item.symbol !== "")
      : topPriceChanges.data;
  }, [symbolChecked, topPriceChanges.data]);

  const tableData = {
    ...topPriceChanges,
    data: filteredData,
  };

  return (
    <DomesticMarketTopPriceChangesContext.Provider
      value={{ tableData, symbolChecked, setSymbolChecked }}
    >
      {children}
    </DomesticMarketTopPriceChangesContext.Provider>
  );
};

export default DomesticMarketTopPriceChangesProvider;

export const  useDomesticMarketTopPriceChangesContext = () =>
  useContext(DomesticMarketTopPriceChangesContext);
